export function managePurchase(state, action) {
  return {
    type: 'MYB_PURCHASE',
    cart: action.cart,
    pnr: action.pnr,
    ancillaryDescriptions: action.ancillaryDescriptions,
    storefront: state.storefront.storefront,
    fareFamily: action.fareFamily,
    emd: action.emds,
  };
}

